"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const DrawerContainer = styled_components_1.default.div `
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  transition: ${(props) => `height ${props.animationDuration}ms ease-in-out, opacity ${props.animationDuration * 0.75}ms ease-in-out`};

  height: ${(props) => props.$isAnimating ? '95%' : '0'};
  z-index: 2;
`;
const DrawerContent = styled_components_1.default.div `
  padding: 20px;
  padding-top: 50px;
  height: 100%;
`;
const StyledCloseButton = (0, styled_components_1.default)(IconButton_1.default) `
  position: absolute !important;
  top: 12px;
  right: 12px;
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 50%;
  padding: 6px;
  z-index: 2;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }

  .MuiSvgIcon-root {
    font-size: 1.25rem;
    color: #555;
  }
`;
const Backdrop = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 1;
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${(props) => (props.$isVisible ? 'auto' : 'none')};
`;
const Drawer = ({ open, onClose, children, containerStyle, contentStyle, animationDuration = 400, }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const [isAnimating, setIsAnimating] = (0, react_1.useState)(false);
    const drawerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        let mountTimer;
        let unmountTimer;
        if (open) {
            setIsVisible(true);
            mountTimer = setTimeout(() => {
                setIsAnimating(true);
            }, 10);
        }
        else {
            setIsAnimating(false);
            unmountTimer = setTimeout(() => {
                setIsVisible(false);
            }, animationDuration);
        }
        return () => {
            clearTimeout(mountTimer);
            clearTimeout(unmountTimer);
        };
    }, [open, animationDuration]);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (open &&
                isVisible &&
                drawerRef.current &&
                event.target instanceof Node &&
                !drawerRef.current.contains(event.target)) {
                const targetElement = event.target;
                if (!targetElement.closest('[aria-label="close drawer"]')) {
                    onClose();
                }
            }
        };
        if (open && isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open, onClose, isVisible]);
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Backdrop, { "$isVisible": open, onClick: onClose }),
        react_1.default.createElement(DrawerContainer, { ref: drawerRef, "$isAnimating": isAnimating, animationDuration: animationDuration, style: containerStyle, role: "dialog", "aria-modal": "true", "aria-hidden": !open },
            react_1.default.createElement(StyledCloseButton, { "aria-label": "close drawer", onClick: onClose },
                react_1.default.createElement(KeyboardArrowDown_1.default, null)),
            react_1.default.createElement(DrawerContent, { style: contentStyle }, children))));
};
exports.default = Drawer;
